module.exports = __webpack_public_path__ + "static/ActaDeck-Book-45c88c5ee5c161bd3348757b81f055ed.woff2";